import _ from 'lodash';

import environment from '../../environment';
import colorbrewer from './colorbrewer';

export const getSegmentTheme = () => {
    const palette = colorbrewer.segments.extra;

    return _(environment.get('CONFIG.FILTERS.SEGMENT'))
        .map()
        .sortBy('id')
        .reduce(
            (theme, segment, index) => {
                if (!_.isEmpty(segment.name)) {
                    theme[segment.name] = palette[index % _.size(palette)];
                }

                return theme;
            },
            { extra: palette }
        );
};

export default getSegmentTheme;



// WEBPACK FOOTER //
// ./src/scripts/core/tools/segment.js